const bannerBottom = () => {
  const banner = document.querySelector('.banner');
  if (!banner) return;
  const header = document.querySelector('.header');
  const form = document.querySelector('#form');

  const trackScroll = () => {
    if (window.innerWidth < 768) return;
    const scrolled = window.pageYOffset;
    if (scrolled < header.offsetTop + header.clientHeight) {
      banner.style.transform = 'translateY(100%)';
    } else if (
      scrolled + document.documentElement.clientHeight >
      form.offsetTop
    ) {
      banner.style.transform = 'translateY(100%)';
    } else if (scrolled < form.offsetTop) {
      banner.style.transform = 'translateY(0)';
    }
  };
  window.addEventListener('scroll', trackScroll);
};

export default bannerBottom;
